import type { SympyBuilder } from "./SympyBuilder";
import type { SemanticExpr } from "../types";
import type { NodeJson } from "@corca/data";

export function traverseRootNode(builder: SympyBuilder, node: NodeJson): SemanticExpr | null {
  if (node.type === "wrapper" && node.children.length === 1) {
    return builder.traverseRootNode(node.children[0]);
  }
  if (node.type === "inline" && node.children.length === 1) {
    return builder.traverseRootNode(node.children[0]);
  }

  if (node.type === "function") {
    if (node.props.key === "function-limit") {
      return builder.parseLimit(node);
    }
    if (
      node.props.key === "function-integral" ||
      node.props.key === "function-indefinite-integral"
    ) {
      return builder.parseIntegral(node);
    }
    if (node.props.key === "function-summation") {
      return builder.parseSumProduct(node, "Sum");
    }
    if (node.props.key === "function-product") {
      return builder.parseSumProduct(node, "Product");
    }
  }

  if (node.type === "operator") {
    if (node.props.operatorType === "derivative") {
      return builder.parseDerivative(node, 1);
    }
    if (node.props.operatorType === "double-derivative") {
      return builder.parseDerivative(node, 2);
    }
  }

  return builder.traverseNode(node, 1);
}
